<template>
  <div id="join">
    <div class="search">
      <el-input placeholder="请输入查找的组织名称" clearable prefix-icon="el-icon-search" v-model.trim="formMore.label"></el-input>
      <!-- <el-select
          ref="choose"
          clearable
          v-model.trim="more"
          placeholder="更多筛选"
          @focus="moreSelect()"
        >
        </el-select> -->
      <el-button type="warning" @click="search1()" size="mini" icon="el-icon-search"
        style="margin-left: 10px;">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" plain size="small" @click="addClick()" v-if="organizationAdd">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      style="width: 100%">

      <el-table-column prop="label" label="律师事务所" sortable width="340">
      </el-table-column>
      <el-table-column prop="code" label="组织代号">
      </el-table-column>
      <el-table-column label="功能">
        <template slot-scope="scope">

          <el-button type="success" plain size="small" @click="editClick(scope.row)" v-if="organizationUpdate">编辑</el-button>
          <el-popconfirm title="是否确定删除？" @confirm="deleteStatus(scope.row)" style="margin-left: 10px">
            <el-button type="warning" plain size="small" slot="reference" v-if="organizationDelete">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes" :total="Total"></el-pagination>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="prev, pager, next, jumper"
        :total="Total"></el-pagination>
    </div>
    <!-- 添加或修改对话框 -->
    <el-dialog :title="AddTitle ? '新增组织' : '修改组织'" :visible.sync="dialogAddVisible" width="720px" append-to-body
      @closed="closeForm()">
      <el-form ref="addRuleForm" :model="addForm" :rules="addFormRules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="上级组织">
              <el-cascader v-model="addForm.pid" :props="{ checkStrictly: true }" :options="organizationList"
                @change="handleChange" clearable></el-cascader>
              <!-- <el-select v-model.trim="addForm.pid" :disabled="!AddTitle && addForm.pid=='00000000-0000-0000-0000-000000000000'" placeholder="请选择"
                class="select" clearable="">
                <el-option v-for="item in organizationList" :key="item.id" :label="item.label" :value="item.id">
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组织名称" prop="label">
              <el-input v-model="addForm.label" placeholder="请输入组织名称" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="组织代号" prop="code">
              <el-input v-model="addForm.code" placeholder="请输入组织代号" />
            </el-form-item>
          </el-col> -->

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSubmitForm">确 定</el-button>
        <el-button @click="closeForm">取 消</el-button>
      </div>
    </el-dialog>



    <!--更多选择!-->
    <!-- <el-dialog
        title="更多筛选"
        :visible.sync="dialogMoreVisible"
        width="40%"
        center=""
        :show-close="true"
      >
        <el-form
          ref="formMore"
          :model="formMore"
          label-width="90px"
          style="min-height: 400px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="组织名称">
                <el-input
                  class="select"
                  v-model.trim="formMore.name"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="组织地址">
                <el-input
                  class="select"
                  v-model.trim="formMore.address"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        
        </el-form>
        <div class="btn">
          <el-button type="primary" @click="search()">搜索</el-button>
        </div>
      </el-dialog> -->
  </div>
</template>
   
<script>
import {
  //CounselList,
  OrganizationList,
  deleteOrganization,
  addOrganization,
  editOrganization,
  pidOrganization,


} from "../../api/set.js";
export default {
  name: "organization",
  data() {
    return {
      list: [],
      loading: true,
      formMore: {
      },
      isPage: true,
      more: "",
      AddTitle: true,
      addForm: {
      },
      organizationList: [
      ],
      addFormRules: {
        label: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入组织代号', trigger: 'blur' },
        ],
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      // dialogFormVisible: false,
      dialogAddVisible: false,
      dialogMoreVisible: false,
      dialogFormTitle: "",
      form: {},
      Total: 10,
      sheetNames: null, //从数据中获取到的sheet页数组
      dialogVisible: false,
      organizationUpdate:false,
      organizationAdd:false,
      organizationDelete:false

    };
  },
  mounted() {
    this.organizationUpdate = this.$store.state.rolesname.includes('organizationUpdate');
    this.organizationAdd = this.$store.state.rolesname.includes('organizationAdd');
    this.organizationDelete = this.$store.state.rolesname.includes('organizationDelete');
    this.search();
    this.getOrganizationList()
  },

  methods: {
    search1(){
      this.currentPage=1
      this.search()
    },
    //查询
    search() {
      let Params = {
        name: this.formMore.label,
        rows: this.pageSize,
        page: this.currentPage,
      };
      OrganizationList(Params)
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if (res.status == 200) {
            let arr = JSON.stringify(res)
            let arr1 = JSON.parse(arr).data.data
            this.tableData = res.data.data;
            this.Total = res.data.total;
          } else {
            this.$message.error('查询失败')
          }

        })
        .catch(() => {
          this.$message.error("查询出错");
        });
      this.dialogMoreVisible = false
    },
    //获取上一级组织列表
    getOrganizationList(){
    
      pidOrganization()
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if (res.status == 200) {
            this.organizationList = res.data.data
            // let obj= {
            //     "value": "00000000-0000-0000-0000-000000000000",
            //     "label": "Root"          
            //   }
            //   this.organizationList.unshift(obj)
          } else {
            this.$message.error('数据获取失败')
          }

        })
        .catch(() => {
          this.$message.error("查询出错");
        });
    

    },
    
    //更改级联选择器
    handleChange(value) {
      if (value) {
        this.addForm.pid = value[value.length-1]
        console.log('value888',  this.addForm.pid);
      }
    },

    //新增
    addClick() {
      this.AddTitle = true
      this.dialogAddVisible = true
    },
    //编辑
    editClick(row) {
      console.log('row', row);
      this.AddTitle = false
      var list = JSON.parse(JSON.stringify(row))
      this.addForm = list
      console.log('nnnn',list);
      // if (this.addForm.pid == '00000000-0000-0000-0000-000000000000') {
      //   this.addForm.pid = ''
      // } 
      this.dialogAddVisible = true
    },
    //删除
    deleteStatus(row) {
      console.log('delete', row);
      let Params = {
        id: row.id,
        status: 9,
      };
      deleteOrganization(Params)
        .then((res) => {
          if(res.data.status != "success"){
            this.$message.error(res.data.message);
            return;
          }
          if (res.status == 200) {
            this.$message.success('删除成功')
            this.search();
            this.getOrganizationList()

          } else {
            this.$message.error('删除失败')
          }

        })
        .catch(() => {
          this.$message.error("删除出错");
        });
    },
    //取消按钮
    closeForm() {
      this.$refs['addRuleForm'].resetFields();
      this.dialogAddVisible = false
      this.addForm = {}
      // this.addForm.pid=''
    },
    //新增确定按钮
    addSubmitForm() {
      this.$refs['addRuleForm'].validate((valid) => {
        if (valid) {
          if (this.AddTitle) {
            let Params = {
              name: this.addForm.label,
              // pid:new Guid(this.addForm.pid),
              pid: this.addForm.pid ? this.addForm.pid : '00000000-0000-0000-0000-000000000000',
              code: this.addForm.code,
            };
            addOrganization(Params)
              .then((res) => {
                if(res.data.status != "success"){
                  this.$message.error(res.data.message);
                  return;
                }
                if (res.status == 200) {
                  this.$message.success('添加成功')
                  this.dialogAddVisible = false
                  this.search();
                  this.getOrganizationList()
                } else {
                  this.$message.error('添加失败')
                }
              })
              .catch(() => {
                this.$message.error("新增出错");
              });
          } else {
            let Params = {
              id: this.addForm.id,
              name: this.addForm.label,
              pid: this.addForm.pid,
              code: this.addForm.code
            };
            console.log('id', this.addForm.id);
            console.log('name', this.addForm.name);

            editOrganization(Params)
              .then((res) => {
                if(res.data.status != "success"){
                  this.$message.error(res.data.message);
                  return;
                }
                if (res.status == 200) {
                  this.$message.success('编辑成功')
                  this.dialogAddVisible = false
                  this.search();
                  this.getOrganizationList()
                } else {
                  this.$message.error('编辑失败')
                }
              })
              .catch(() => {
                this.$message.error("编辑出错");
              });
          }
        } else {
          this.$message.error('校验失败')
          return false;
        }
      });

    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },

    //更多筛选
    moreSelect() {
      //更多选择
      this.$refs.choose.blur();
      this.dialogMoreVisible = true;
    },
    // // 关闭dialog时清空表单
    // closeForm(formName) {
    //   this.$refs[formName].resetFields();
    //   this.Upload.FileList = [];
    // },

  },
  computed: {
    // total() {
    //   return this.tableData.length;
    //   // return 9
    // },
  },
};
</script>
  
<style lang="less" scoped>
#join {

  // position: relative;
  .search {
    box-sizing: border-box;
    display: flex;
    padding: 24px;
    width: 100%;

    .el-input {
      width: 20%;
    }

    ::v-deep .el-input__inner {
      // width: 80% !important;
      // width: 300px;
      height: 45px;
      background-color: #fafafa;
      border: 0 !important;
    }

    .el-select {
      margin: 0 10px;
      width: 150px;
    }
  }

  .pagination {
    // position: absolute;
    // bottom: 40px;
    // right: 80px;
    margin: 20px 20px;
    // float: right;
    display: flex;
    justify-content: space-between;

    .el-pagination {
      padding-right: 50px;
    }
  }

  .sel-input-all {
    width: 70%;
  }

  .fj {
    // display: inline-flex;
    display: flex;
    align-items: center;
    background: #f5f7fa;
    justify-content: flex-start;
    padding: 10px;
    padding-right: 20px;
    margin-bottom: 10px;
  }

  .input {
    width: 75%;
  }

  .img {
    width: 100%;
  }

  .word {
    line-height: 18px;
    cursor: default;
  }

  .look {
    color: #fe964a;
  }

  .down {
    color: #2bc887;
    margin-left: 10px;
  }

  .dialog-footer {
    margin-bottom: 5%;
  }

  .select {
    width: 10vw;
    margin-bottom: 1rem;
  }

  .btn {
    width: 100%;
    text-align: center;
  }
}
</style>
  